import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Check } from "lucide-react";
import { ScrollArea } from "../ui/scroll-area";

const PricingOptions = () => {
  return (
    <section id="pricing" className="py-20">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">Simple, honest pricing</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Half the price of Jane. No per-seat fees. No hidden add-ons. First 20 therapists lock in the founding member rate forever.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 p-8">

          {/* Starter */}
          <Card className="border-2 border-gray-200">
            <CardHeader>
              <CardTitle className="text-2xl">Starter</CardTitle>
              <div className="mt-2 text-4xl font-bold text-primary">Free <span className="text-base font-normal text-gray-500">forever</span></div>
              <CardDescription className="text-base">Get on the platform and see if it works for you. No credit card required.</CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3">
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Public therapist profile</span></li>
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Up to 3 active patients</span></li>
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Basic intake routing</span></li>
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Access to screening tools</span></li>
              </ul>
            </CardContent>
            <CardFooter>
              <a href="/therapists/sign_up" className="w-full">
                <Button variant="outline" className="w-full rounded-full px-8 py-6 h-auto text-lg">
                  Join Free
                </Button>
              </a>
            </CardFooter>
          </Card>

          {/* Growth Founding Member */}
          <Card className="border-2 border-green-500 relative">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-green-500 text-white text-sm font-semibold px-4 py-1 rounded-full whitespace-nowrap">
              Founding member — 20 spots
            </div>
            <CardHeader>
              <CardTitle className="text-2xl">Growth</CardTitle>
              <div className="mt-2">
                <span className="text-4xl font-bold text-primary">CAD $39</span>
                <span className="text-base font-normal text-gray-500">/month</span>
                <div className="text-sm text-gray-400 line-through">Regular price $59/month</div>
              </div>
              <CardDescription className="text-base">Everything to run a full practice on MindPulse. Founding rate locked in forever.</CardDescription>
            </CardHeader>
            <CardContent>
              <ScrollArea className="h-48">
                <ul className="space-y-3">
                  <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Unlimited patients</span></li>
                  <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Video appointments (Whereby)</span></li>
                  <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Group class sessions</span></li>
                  <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Full screening library (40+ tools)</span></li>
                  <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Calendar + scheduling</span></li>
                  <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Cultural + language matching</span></li>
                </ul>
              </ScrollArea>
            </CardContent>
            <CardFooter>
              <a href="/therapists/sign_up" className="w-full">
                <Button className="w-full rounded-full text-white px-8 py-6 h-auto text-lg">
                  Claim Founding Spot
                </Button>
              </a>
            </CardFooter>
          </Card>

          {/* Practice */}
          <Card className="border-2 border-gray-200">
            <CardHeader>
              <CardTitle className="text-2xl">Practice</CardTitle>
              <div className="mt-2 text-4xl font-bold text-primary">CAD $79 <span className="text-base font-normal text-gray-500">/month</span></div>
              <CardDescription className="text-base">For clinics and group practices with multiple therapists.</CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3">
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Everything in Growth</span></li>
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Up to 5 therapist seats</span></li>
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Admin dashboard</span></li>
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Custom intake branding</span></li>
                <li className="flex"><Check className="h-5 w-5 text-green-500 mr-2 shrink-0" /><span>Priority support</span></li>
              </ul>
            </CardContent>
            <CardFooter>
              <a href="https://calendly.com/safdarzeeshan/mindpulse-therapy" className="w-full">
                <Button variant="outline" className="w-full border-primary/90 hover:bg-primary text-primary hover:text-white rounded-full px-8 py-6 h-auto text-lg">
                  Book a Demo
                </Button>
              </a>
            </CardFooter>
          </Card>

        </div>
      </div>
    </section>
  );
};

export default PricingOptions;
